export default "__VITE_ASSET__D6RfC6QV__"